import React from 'react';
import styled from 'react-emotion';
import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';
import Warning from '@material-ui/icons/Warning';
import Error from '@material-ui/icons/Error';
import Info from '@material-ui/icons/Info';
import CheckCircle from '@material-ui/icons/CheckCircle';

export const AlertTypes = {
  warning: 'warning',
  error: 'error',
  success: 'success',
  information: 'information',
};

const AlertColors = {
  [AlertTypes.warning]: {
    background: `${colors.designSystem.background.light.warning}`,
    iconColor: `${colors.designSystem.blackOpacity60}`,
  },
  [AlertTypes.error]: {
    background: `${colors.designSystem.background.light.error}`,
    iconColor: `${colors.designSystem.error}`,
  },
  [AlertTypes.information]: {
    background: `${colors.designSystem.background.light.information}`,
    iconColor: `${colors.designSystem.information}`,
  },
  [AlertTypes.success]: {
    background: `${colors.designSystem.background.light.success}`,
    iconColor: `${colors.designSystem.success}`,
  },
};

export const AlertContainer = styled('div')`
  background-color: ${(props) => AlertColors[props.alertType].background};
  display: flex;
  border-radius: ${theme.borderRadius.medium};
  padding: ${theme.spacing.xSmall} ${theme.spacing.medium};
  color: ${colors.designSystem.blackOpacity87};
  margin-bottom: ${theme.spacing.large};
  font-size: ${theme.font.size.copy};
  line-height: ${theme.font.lineHeight.copy};
  flex-direction: row;
  justify-content: space-around;
`;

export const AlertMessage = styled('div')`
  margin-left: ${theme.spacing.small};
`;

export const AlertIcon = styled((props) => {
  const { alertType } = props;
  const style = {
    color: AlertColors[alertType].iconColor,
    fontSize: '20px',
  };
  switch (alertType) {
    case AlertTypes.warning:
      return <Warning style={{ ...style }} />;
    case AlertTypes.error:
      return <Error style={{ ...style }} />;
    case AlertTypes.information:
      return <Info style={{ ...style }} />;
    case AlertTypes.success:
      return <CheckCircle style={{ ...style }} />;
    default:
      return <Info />;
  }
})``;
